import axios from 'axios';
import store from './store';
import qs from 'qs';
import Loading from '../components/js/Loading.vue'
import ElementUI from 'element-ui';

/**
 * axios  配置
 */
// axios.defaults.baseURL = 'https://api.example.com'

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';
// http request 请求拦截器
axios.interceptors.request.use(
  config => {
    // console.log(config.url)
    config.headers.common['X-SYSTEM'] = 'PC';
    let curArticleId = localStorage.getItem('curArticleId');
    if (curArticleId) {
      config.headers.common['myNewsId'] = curArticleId;
    }

    if (config.method === 'post') {
      config.data = config.data instanceof FormData ? config.data : qs.stringify(config.data);
    }
    return config;
  },
  error => {
    console.error('请求错误信息');
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// http response 响应拦截器
axios.interceptors.response.use(
  response => {
    // 相应 处理header
    if (response.headers.authorization) {
      localStorage.setItem('Authorization', response.headers.authorization);
    }

    switch (response.data.code) {
      case 401:
      case 901:
        store.commit('showLoginDialog');
        return Promise.reject(response.data);
      case 3002: // 需要购买黄金会员
      case 3003: // 需要购买白银会员
      case 3004: // 需要升级黄金会员
        console.log(response.data.code)
        store.commit('showPriceDialog', response.data.code);
        return Promise.reject(response.data);
      case 200:
        return response.data;
      default:
        ElementUI.Message({
          message: response.data.msg,
          type: 'error'
        });
        return Promise.reject(response.data.msg);
    }
  },
  error => {
    Loading.stopLoading();
    if (error.response) {
      ElementUI.Message({
        message: '系统异常，错误码【' + error.response.status + '】',
        type: 'error'
      });
      return Promise.reject(error.response.data);
    }
  }
);

axios.getWithLoading = function (url) {
  Loading.startLoading()
  return new Promise((resolve, reject) => {
    axios.get(url).then(resp => { Loading.stopLoading(); resolve(resp) }).catch(error => { reject(error) })
  })
}

axios.postWithLoading = function (url, param) {
  Loading.startLoading()
  return new Promise((resolve, reject) => {
    axios.post(url, param).then(resp => { Loading.stopLoading(); resolve(resp) }).catch(error => { Loading.stopLoading(); reject(error) })
  })
}

export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.js